import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash';
import config from '../config';
import store from '../store';

// Containers
import Full from '@/containers/Full';

// Views
import AppContent from '@/views/content/Index';
import Dashboard from '@/views/Dashboard';
import DashboardSearch from '@/views/mainSearch/DashboardSearch';
import Search from '@/views/Search';
import Robots from '@/views/Robots';
import FlowpaperList from '@/views/flowpaper/Index';
import featuredContent from '@/views/featuredContent/Index';
import PublicFiles from '@/views/publicFiles/Index';

// Content Views
import PublicationList from '@/views/content/publication/Index';
import PublicationEdit from '@/views/content/publication/Edit';
import PublicationNew from '@/views/content/publication/New';

import CorrespondenceList from '@/views/content/correspondence/Index';
import CorrespondenceEdit from '@/views/content/correspondence/Edit';
import CorrespondenceNew from '@/views/content/correspondence/New';

import PersonList from '@/views/content/people/Index';
import PersonsDuplicatesList from '@/views/content/people/Duplicates';
import PersonEdit from '@/views/content/people/Edit';
import PersonNew from '@/views/content/people/New';

import NewsList from '@/views/content/news/Index';
import NewsEdit from '@/views/content/news/Edit';
import NewsNew from '@/views/content/news/New';

import ArticleList from '@/views/content/articles/Index';
import ArticleEdit from '@/views/content/articles/Edit';
import ArticlesNew from '@/views/content/articles/New';

import LessonList from '@/views/content/lessons/Index';
import LessonEdit from '@/views/content/lessons/Edit';
import LessonNew from '@/views/content/lessons/New';

import LocationList from '@/views/content/locations/Index';
import LocationEdit from '@/views/content/locations/Edit';
import LocationNew from '@/views/content/locations/New';

import LetterbookList from '@/views/content/letterbooks/Index';
import LetterbookEdit from '@/views/content/letterbooks/Edit';
import LetterbookNew from '@/views/content/letterbooks/New';

import EventList from '@/views/content/events/Index';
import EventEdit from '@/views/content/events/Edit';
import EventNew from '@/views/content/events/New';

// issuesAndAnswers
import IssuesAndAnswersList from '@/views/content/issuesAndAnswers/Index';
import IssuesAndAnswersEdit from '@/views/content/issuesAndAnswers/Edit';
import IssuesAndAnswersNew from '@/views/content/issuesAndAnswers/New';

import ImageList from '@/views/content/images/Index';
import ImageEdit from '@/views/content/images/Edit';
import ImageNew from '@/views/content/images/New';

import GalleryList from '@/views/content/gallery/Index';
import GalleryNew from '@/views/content/gallery/New';
import GalleryEdit from '@/views/content/gallery/Edit';
import GalleryManageImages from '@/views/content/gallery/ManageImages';
import GalleryAddImages from '@/views/content/gallery/AddImages';

import DocumentList from '@/views/content/documents/Index';
import DocumentEdit from '@/views/content/documents/Edit';
import DocumentNew from '@/views/content/documents/New';

import DocumentFilesList from '@/views/content/documentFiles/Index';
import DocumentFilesEdit from '@/views/content/documentFiles/Edit';
import DocumentFilesNew from '@/views/content/documentFiles/New';
import DocumentFilesManageDocs from '@/views/content/documentFiles/ManageDocs';
import DocumentFilesAddDocs from '@/views/content/documentFiles/AddDocs';

import AudioList from '@/views/content/audio/Index';
import AudioEdit from '@/views/content/audio/Edit';
import AudioNew from '@/views/content/audio/New';

import AlbumList from '@/views/content/albums/Index';
import AlbumEdit from '@/views/content/albums/Edit';
import AlbumNew from '@/views/content/albums/New';
import AlbumManageTracks from '@/views/content/albums/ManageTracks';
import AlbumOrderTracks from '@/views/content/albums/OrderTracks';
import AlbumAddTracks from '@/views/content/albums/AddTracks';

import VideoList from '@/views/content/video/Index';
import VideoEdit from '@/views/content/video/Edit';
import VideoNew from '@/views/content/video/New';

import VideoSeriesList from '@/views/content/videoSeries/Index';
import VideoSeriesEdit from '@/views/content/videoSeries/Edit';
import VideoSeriesNew from '@/views/content/videoSeries/New';
import VideoSeriesManageVideos from '@/views/content/videoSeries/ManageVideos';
import VideoSeriesOrderVideos from '@/views/content/videoSeries/OrderVideos';
import VideoSeriesAddVideos from '@/views/content/videoSeries/AddVideos';

import PamphletList from '@/views/content/pamphlets/Index';
import PamphletEdit from '@/views/content/pamphlets/Edit';
import PamphletNew from '@/views/content/pamphlets/New';

import TopicList from '@/views/content/topics/Index';
import TopicEdit from '@/views/content/topics/Edit';
import TopicNew from '@/views/content/topics/New';

import FaqList from '@/views/content/faq/Index';
import FaqEdit from '@/views/content/faq/Edit';
import FaqNew from '@/views/content/faq/New';

import VocabularyList from '@/views/taxonomy/vocabulary/Index';
import VocabularyEdit from '@/views/taxonomy/vocabulary/Edit';
import VocabularyNew from '@/views/taxonomy/vocabulary/New';
import VocabularyOrder from '@/views/taxonomy/vocabulary/TermsOrder';

import TermsList from '@/views/taxonomy/terms/Index';
import TermsEdit from '@/views/taxonomy/terms/Edit';
import TermsNew from '@/views/taxonomy/terms/New';

import MediaList from '@/views/media/Index';

import MenuList from '@/views/menu/Index';
import MenuNew from '@/views/menu/New';
import MenuEdit from '@/views/menu/Edit';

import StaffList from '@/views/staff/Index';
import StaffEdit from '@/views/staff/Edit';
import StaffNew from '@/views/staff/New';

import DirectorsList from '@/views/directors/Index';
import DirectorsEdit from '@/views/directors/Edit';
import DirectorsNew from '@/views/directors/New';

import BranchOfficesList from '@/views/branchOffices/Index';
import BranchOfficesEdit from '@/views/branchOffices/Edit';
import BranchOfficesNew from '@/views/branchOffices/New';

import SitePagesList from '@/views/sitePages/Index';
import SitePagesEdit from '@/views/sitePages/Edit';
import SitePagesNew from '@/views/sitePages/New';

import RedirectsList from '@/views/redirects/Index';
import RedirectsEdit from '@/views/redirects/Edit';
import RedirectsNew from '@/views/redirects/New';

import UsersList from '@/views/users/Index';
import UsersEdit from '@/views/users/Edit';
import UsersNew from '@/views/users/New';

import RolesList from '@/views/roles/Index';
import RolesEdit from '@/views/roles/Edit';
import RolesNew from '@/views/roles/New';

import QaList from '@/views/content/qa/Index';
import QaEdit from '@/views/content/qa/Edit';
import QaNew from '@/views/content/qa/New';
import QaManageDocs from '@/views/content/qa/ManageDocs';
import QaAddDocs from '@/views/content/qa/AddDocs';

import PuzzleImageIndex from '@/views/games/puzzles/Index';
import PuzzleImageAdd from '@/views/games/puzzles/New';
import PuzzleImageEdit from '@/views/games/puzzles/Edit';

import MemoryImagesIndex from '@/views/games/memory/Index';
import MemoryImagesNew from '@/views/games/memory/New';
import MemoryImagesEdit from '@/views/games/memory/Edit';

import PaintingImagesIndex from '@/views/games/painting/Index';
import PaintingImagesNew from '@/views/games/painting/New';
import PaintingImagesEdit from '@/views/games/painting/Edit';

import QuizImagesIndex from '@/views/games/quiz/Index';
import QuizImagesNew from '@/views/games/quiz/New';
import QuizImagesEdit from '@/views/games/quiz/Edit';

import EditorsPicksList from '@/views/editorsPicks/EditorsPicksList.vue';
import EditorsPicksEditArticles from '@/views/editorsPicks/EditorsPicksEditArticles.vue';
import EditorsPicksEditFAQ from '@/views/editorsPicks/EditorsPicksEditFAQ.vue';
import EditorsPicksEditDocuments from '@/views/editorsPicks/EditorsPicksEditDocuments.vue';

// Unauthorized pages
import Login from '@/views/unauthorizedPages/Login';
import TwoFactorAuthentication from '@/views/unauthorizedPages/TwoFactorAuthentication';
import RequestResetPassword from '@/views/unauthorizedPages/RequestResetPassword';
import ResetPassword from '@/views/unauthorizedPages/ResetPassword';
import AccountSettings from '@/views/accountSettings/Index';
import Google2FA from '@/views/accountSettings/Google2FA/Google2FA';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        dontNeedAuth: true,
      },
    },
    {
      path: '/two-factor-authentication',
      name: 'TwoFactorAuthentication',
      component: TwoFactorAuthentication,
      meta: {
        dontNeedAuth: true,
      },
    },
    {
      path: '/password/reset',
      name: 'RequestResetPassword',
      component: RequestResetPassword,
      meta: {
        dontNeedAuth: true,
      },
    },
    {
      path: '/password/reset/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        dontNeedAuth: true,
      },
    },
    {
      path: '/admin',
      redirect: '/admin/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'account-settings',
          name: 'Account Settings',
          component: AccountSettings,
        },
        {
          path: 'account-settings/set-up-google2fa',
          name: 'Set Up Google2FA',
          component: Google2FA,
        },
        {
          path: 'main-search',
          name: 'Dashboard Search',
          component: DashboardSearch,
          meta: {
            permissions: [230],
          },
        },
        {
          path: 'search',
          name: 'Search settings',
          component: Search,
          meta: {
            permissions: [230],
          },
        },
        {
          path: 'robots',
          name: 'Robots settings',
          component: Robots,
          meta: {
            permissions: [97],
          },
        },
        {
          path: 'redirects',
          name: 'Redirects',
          component: RedirectsList,
          meta: {
            permissions: [98],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'RedirectsEdit',
              component: RedirectsEdit,
            },
            {
              path: 'new',
              name: 'RedirectsNew',
              component: RedirectsNew,
            },
          ],
        },
        {
          path: 'featured-content',
          name: 'featuredContent',
          component: featuredContent,
          meta: {
            permissions: [100],
          },
        },
        {
          path: 'flowpaper',
          name: 'Flowpaper',
          component: FlowpaperList,
          meta: {
            permissions: [138],
          },
        },
        {
          path: 'roles',
          name: 'Roles',
          component: RolesList,
          meta: {
            permissions: [96],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'RolesEdit',
              component: RolesEdit,
            },
            {
              path: 'new',
              name: 'RolesNew',
              component: RolesNew,
            },
          ],
        },
        {
          path: 'users',
          name: 'Users',
          component: UsersList,
          meta: {
            permissions: [95],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'UsersEdit',
              component: UsersEdit,
            },
            {
              path: 'new',
              name: 'UsersNew',
              component: UsersNew,
            },
          ],
        },
        {
          path: 'media',
          name: 'Media',
          component: MediaList,
          meta: {
            permissions: [99],
          },
        },
        {
          path: 'menu',
          name: 'Menu',
          component: MenuList,
          meta: {
            permissions: [102],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'MenuEdit',
              component: MenuEdit,
            },
            {
              path: 'new',
              name: 'MenuNew',
              component: MenuNew,
            },
          ],
        },
        {
          path: 'public',
          name: 'PublicFiles',
          component: PublicFiles,
          meta: {
            permissions: [103],
          },
        },
        {
          path: 'staff',
          name: 'Staff',
          component: StaffList,
          meta: {
            permissions: [116],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'StaffEdit',
              component: StaffEdit,
            },
            {
              path: 'new',
              name: 'StaffNew',
              component: StaffNew,
            },
          ],
        },
        {
          path: 'directors',
          name: 'Directors',
          component: DirectorsList,
          meta: {
            permissions: [117],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'DirectorsEdit',
              component: DirectorsEdit,
            },
            {
              path: 'new',
              name: 'DirectorsNew',
              component: DirectorsNew,
            },
          ],
        },
        {
          path: 'branch-offices',
          name: 'BranchOffices',
          component: BranchOfficesList,
          meta: {
            permissions: [118, 256],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'BranchOfficesEdit',
              component: BranchOfficesEdit,
            },
            {
              path: 'new',
              name: 'BranchOfficesNew',
              component: BranchOfficesNew,
            },
          ],
        },
        {
          path: 'site-pages',
          name: 'SitePages',
          component: SitePagesList,
          meta: {
            permissions: [119],
          },
          children: [
            {
              path: 'edit/:id',
              name: 'SitePagesEdit',
              component: SitePagesEdit,
            },
            {
              path: 'new',
              name: 'SitePagesNew',
              component: SitePagesNew,
            },
          ],
        },
        {
          path: 'taxonomy',
          name: 'Taxonomy',
          component: AppContent,
          meta: {
            permissions: [231],
          },
          children: [
            {
              path: 'vocabulary',
              name: 'Vocabulary',
              component: VocabularyList,
              meta: {
                permissions: [232, 233, 234, 235, 236],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'VocabularyEdit',
                  component: VocabularyEdit,
                },
                {
                  path: 'new',
                  name: 'VocabularyNew',
                  component: VocabularyNew,
                },
                {
                  path: 'order/:id',
                  name: 'VocabularyOrder',
                  component: VocabularyOrder,
                },
              ],
            },
            {
              path: 'terms',
              name: 'Terms',
              component: TermsList,
              meta: {
                permissions: [237, 238, 239, 240, 241],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'TermsEdit',
                  component: TermsEdit,
                },
                {
                  path: 'new',
                  name: 'TermsNew',
                  component: TermsNew,
                },
              ],
            },
          ],
        },
        {
          path: 'content',
          name: 'Content',
          component: AppContent,
          meta: {
            permissions: [89, 90, 91, 92, 93, 94],
          },
          children: [
            {
              path: 'article',
              name: 'ArticleList',
              component: ArticleList,
              meta: {
                permissions: [104, 105, 106, 107, 108, 109],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'ArticleEdit',
                  component: ArticleEdit,
                },
                {
                  path: 'new',
                  name: 'ArticlesNew',
                  component: ArticlesNew,
                },
              ],
            },
            {
              path: 'book',
              name: 'LetterbookList',
              component: LetterbookList,
              meta: {
                permissions: [110, 111, 112, 113, 114, 115],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'LetterbookEdit',
                  component: LetterbookEdit,
                },
                {
                  path: 'new',
                  name: 'LetterbookNew',
                  component: LetterbookNew,
                },
              ],
            },
            {
              path: 'correspondence',
              name: 'CorrespondenceList',
              component: CorrespondenceList,
              meta: {
                permissions: [120, 121, 122, 123, 124, 125],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'CorrespondenceEdit',
                  component: CorrespondenceEdit,
                },
                {
                  path: 'new',
                  name: 'CorrespondenceNew',
                  component: CorrespondenceNew,
                },
              ],
            },
            {
              path: 'document_files',
              name: 'DocumentFilesList',
              component: DocumentFilesList,
              meta: {
                permissions: [193, 194, 195, 196, 197, 198],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'DocumentFilesEdit',
                  component: DocumentFilesEdit,
                },
                {
                  path: 'manage-docs/:id',
                  name: 'DocumentFilesManageDocs',
                  component: DocumentFilesManageDocs,
                },
                {
                  path: 'add-docs/:id',
                  name: 'DocumentFilesAddDocs',
                  component: DocumentFilesAddDocs,
                },
                {
                  path: 'new',
                  name: 'DocumentFilesNew',
                  component: DocumentFilesNew,
                },
              ],
            },
            {
              path: 'event',
              name: 'EventList',
              component: EventList,
              meta: {
                permissions: [126, 127, 128, 129, 130, 131],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'EventEdit',
                  component: EventEdit,
                },
                {
                  path: 'new',
                  name: 'EventNew',
                  component: EventNew,
                },
              ],
            },
            {
              path: 'faq',
              name: 'FaqList',
              component: FaqList,
              meta: {
                permissions: [132, 133, 134, 135, 136, 137],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'FaqEdit',
                  component: FaqEdit,
                },
                {
                  path: 'new',
                  name: 'FaqNew',
                  component: FaqNew,
                },
              ],
            },
            {
              path: 'lesson',
              name: 'LessonList',
              component: LessonList,
              meta: {
                permissions: [139, 140, 141, 142, 143, 144],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'LessonEdit',
                  component: LessonEdit,
                },
                {
                  path: 'new',
                  name: 'LessonNew',
                  component: LessonNew,
                },
              ],
            },
            {
              path: 'location',
              name: 'LocationList',
              component: LocationList,
              meta: {
                permissions: [145, 146, 147, 148, 149, 150],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'LocationEdit',
                  component: LocationEdit,
                },
                {
                  path: 'new',
                  name: 'LocationNew',
                  component: LocationNew,
                },
              ],
            },
            {
              path: 'media_audio',
              name: 'AudioList',
              component: AudioList,
              meta: {
                permissions: [181, 182, 183, 184, 185, 186],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'AudioEdit',
                  component: AudioEdit,
                },
                {
                  path: 'new',
                  name: 'AudioNew',
                  component: AudioNew,
                },
              ],
            },
            {
              path: 'media_audio_album',
              name: 'AlbumList',
              component: AlbumList,
              meta: {
                permissions: [175, 176, 177, 178, 179, 180],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'AlbumEdit',
                  component: AlbumEdit,
                },
                {
                  path: 'manage-tracks/:id',
                  name: 'AlbumManageTracks',
                  component: AlbumManageTracks,
                },
                {
                  path: 'order-tracks/:id',
                  name: 'AlbumOrderTracks',
                  component: AlbumOrderTracks,
                },
                {
                  path: 'add-tracks/:id',
                  name: 'AlbumAddTracks',
                  component: AlbumAddTracks,
                },
                {
                  path: 'new',
                  name: 'AlbumNew',
                  component: AlbumNew,
                },
              ],
            },
            {
              path: 'media_doc',
              name: 'DocumentList',
              component: DocumentList,
              meta: {
                permissions: [187, 188, 189, 190, 191, 192],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'DocumentEdit',
                  component: DocumentEdit,
                },
                {
                  path: 'new',
                  name: 'DocumentNew',
                  component: DocumentNew,
                },
              ],
            },
            {
              path: 'issues_and_answers',
              name: 'IssuesAndAnswersList',
              component: IssuesAndAnswersList,
              meta: {
                permissions: [248, 249, 250, 251, 252, 253],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'IssuesAndAnswersEdit',
                  component: IssuesAndAnswersEdit,
                },
                {
                  path: 'new',
                  name: 'IssuesAndAnswersNew',
                  component: IssuesAndAnswersNew,
                },
              ],
            },
            {
              path: 'media_image',
              name: 'ImageList',
              component: ImageList,
              meta: {
                permissions: [157, 158, 159, 160, 161, 162],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'ImageEdit',
                  component: ImageEdit,
                },
                {
                  path: 'new',
                  name: 'ImageNew',
                  component: ImageNew,
                },
              ],
            },
            {
              path: 'media_image_gallery',
              name: 'GalleryList',
              component: GalleryList,
              meta: {
                permissions: [151, 152, 153, 154, 155, 156],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'GalleryEdit',
                  component: GalleryEdit,
                },
                {
                  path: 'manage-images/:id',
                  name: 'GalleryManageImages',
                  component: GalleryManageImages,
                },
                {
                  path: 'add-images/:id',
                  name: 'GalleryAddImages',
                  component: GalleryAddImages,
                },
                {
                  path: 'new',
                  name: 'GalleryNew',
                  component: GalleryNew,
                },
              ],
            },
            {
              path: 'media_video',
              name: 'VideoList',
              component: VideoList,
              meta: {
                permissions: [169, 170, 171, 172, 173, 174],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'VideoEdit',
                  component: VideoEdit,
                },
                {
                  path: 'new',
                  name: 'VideoNew',
                  component: VideoNew,
                },
              ],
            },
            {
              path: 'media_video_series',
              name: 'VideoSeriesList',
              component: VideoSeriesList,
              meta: {
                permissions: [163, 164, 165, 166, 167, 168],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'VideoSeriesEdit',
                  component: VideoSeriesEdit,
                },
                {
                  path: 'manage-videos/:id',
                  name: 'VideoSeriesManageVideos',
                  component: VideoSeriesManageVideos,
                },
                {
                  path: 'order-videos/:id',
                  name: 'VideoSeriesOrderVideos',
                  component: VideoSeriesOrderVideos,
                },
                {
                  path: 'add-videos/:id',
                  name: 'VideoSeriesAddVideos',
                  component: VideoSeriesAddVideos,
                },
                {
                  path: 'new',
                  name: 'VideoSeriesNew',
                  component: VideoSeriesNew,
                },
              ],
            },
            {
              path: 'news',
              name: 'NewsList',
              component: NewsList,
              meta: {
                permissions: [199, 200, 201, 202, 203, 204],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'NewsEdit',
                  component: NewsEdit,
                },
                {
                  path: 'new',
                  name: 'NewsNew',
                  component: NewsNew,
                },
              ],
            },
            {
              path: 'pamphlet',
              name: 'PamphletList',
              component: PamphletList,
              meta: {
                permissions: [205, 206, 207, 208, 209, 210],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'PamphletEdit',
                  component: PamphletEdit,
                },
                {
                  path: 'new',
                  name: 'PamphletNew',
                  component: PamphletNew,
                },
              ],
            },
            {
              path: 'person',
              name: 'PersonList',
              component: PersonList,
              meta: {
                permissions: [211, 212, 213, 214, 215, 216, 217],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'PersonEdit',
                  component: PersonEdit,
                },
                {
                  path: ':id/duplicates',
                  name: 'PersonDuplicates',
                  component: PersonsDuplicatesList,
                },
                {
                  path: 'new',
                  name: 'PersonNew',
                  component: PersonNew,
                },
              ],
            },
            {
              path: 'publication',
              name: 'PublicationList',
              component: PublicationList,
              meta: {
                permissions: [218, 219, 220, 221, 222, 223],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'PublicationEdit',
                  component: PublicationEdit,
                },
                {
                  path: 'new',
                  name: 'PublicationNew',
                  component: PublicationNew,
                },
              ],
            },
            {
              path: 'questions_and_answers',
              name: 'QaList',
              component: QaList,
              meta: {
                permissions: [224, 225, 226, 227, 228, 229],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'QaEdit',
                  component: QaEdit,
                },
                {
                  path: 'new',
                  name: 'QaNew',
                  component: QaNew,
                },
                {
                  path: 'manage-docs/:id',
                  name: 'QaManageDocs',
                  component: QaManageDocs,
                },
                {
                  path: 'add-docs/:id',
                  name: 'QaAddDocs',
                  component: QaAddDocs,
                },
              ],
            },
            {
              path: 'topic',
              name: 'TopicList',
              component: TopicList,
              meta: {
                permissions: [242, 243, 244, 245, 246, 247],
              },
              children: [
                {
                  path: 'edit/:id',
                  name: 'TopicEdit',
                  component: TopicEdit,
                },
                {
                  path: 'new',
                  name: 'TopicNew',
                  component: TopicNew,
                },
              ],
            },
          ],
        },
        {
          path: 'puzzle-game-images',
          name: 'Puzzle Game',
          component: PuzzleImageIndex,
          meta: {
            permissions: [254],
          },
          children: [
            {
              path: 'new',
              name: 'Add Puzzle Image',
              component: PuzzleImageAdd,
            },
            {
              path: 'edit/:id',
              name: 'Edit Puzzle Image',
              component: PuzzleImageEdit,
            },
          ],
        },
        {
          path: 'memory-game-images',
          name: 'Memory Game',
          component: MemoryImagesIndex,
          meta: {
            permissions: [254],
          },
          children: [
            {
              path: 'new',
              name: 'Add Memory Image',
              component: MemoryImagesNew,
              props: true,
            },
            {
              path: 'edit/:id',
              name: 'Edit Memory Image',
              component: MemoryImagesEdit,
              props: true,
            },
          ],
        },
        {
          path: 'painting-game-images',
          name: 'Painting Game',
          component: PaintingImagesIndex,
          meta: {
            permissions: [254],
          },
          children: [
            {
              path: 'new',
              name: 'Add Painting Image',
              component: PaintingImagesNew,
              props: true,
            },
            {
              path: 'edit/:id',
              name: 'Edit Painting Image',
              component: PaintingImagesEdit,
              props: true,
            },
          ],
        },
        {
          path: 'quiz-game-images',
          name: 'Quiz Game',
          component: QuizImagesIndex,
          meta: {
            permissions: [254],
          },
          children: [
            {
              path: 'new',
              name: 'Add Quiz Image',
              component: QuizImagesNew,
              props: true,
            },
            {
              path: 'edit/:id',
              name: 'Edit Quiz Image',
              component: QuizImagesEdit,
              props: true,
            },
          ],
        },
        {
          path: 'editors-picks',
          name: 'Editors Picks',
          component: EditorsPicksList,
          meta: {
            permissions: [255],
          },
          children: [
            {
              path: 'edit-articles',
              name: 'Editors Picks Edit Articles',
              component: EditorsPicksEditArticles,
            },
            {
              path: 'edit-faq',
              name: 'Editors Picks Edit FAQ',
              component: EditorsPicksEditFAQ,
            },
            {
              path: 'edit-documents',
              name: 'Editors Picks Edit Documents',
              component: EditorsPicksEditDocuments,
            },
          ],
        },
      ],
    },
    {
      path: '*',
      redirect: localStorage.getItem('tokenStorage') ? '/admin/dashboard' : '/login',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Scroll to top after each transition
  document.getElementsByTagName('html')[0].scrollTop = 0;

  if (to.matched.some(record => record.meta.permissions)) {
    const metaPermissions = to.matched.reduce((accumulator, currentValue) => {
      if (currentValue.meta.permissions) {
        return accumulator.concat(currentValue.meta.permissions);
      }
      return accumulator;
    }, []);
    let permissions = [];
    if (store.state.user.info && store.state.user.info.roles) {
      permissions = store.getters['user/getPermissions'];
    } else {
      try {
        const user = JSON.parse(localStorage.getItem(config.userStorage.name));
        const permissionsArrs = user.roles.map(role => role.permissions);
        for (let i = 0; i < permissionsArrs.length; i += 1) {
          permissions = permissions.concat(permissionsArrs[i]);
        }
      } catch (error) { permissions = []; }
    }
    permissions = permissions.map(item => item.id);
    if (_.xor(permissions, metaPermissions).length === permissions.length + metaPermissions.length) {
      store.commit('notifications/setDangerNotification', 'Access denied!');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js